import axios from "axios";

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/users";

/**
 * Submits an offboarding request for a user.
 *
 * The axios error is deliberately propagated as-is: the caller distinguishes a 403 (the
 * orderer may not offboard for this customer) from other failures, and that needs the
 * original `error.response`.
 *
 * @param {object} payload - The body from `buildOffboardingPayload`
 * @param {string} apiAccessToken - Bearer token for the API
 * @returns {Promise<{caseReference: string, scheduled: boolean}>} The registered case
 */
export async function submitOffboarding(payload, apiAccessToken) {
  const response = await axios.post(`${baseUrl}/Offboarding/submit`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${apiAccessToken}`,
    },
  });

  return response.data;
}
